import { render } from "./HeroPost.vue?vue&type=template&id=36093dc6&scoped=true&ts=true"
import script from "./HeroPost.ts?vue&type=script&lang=ts"
export * from "./HeroPost.ts?vue&type=script&lang=ts"

import "./HeroPost.scss?vue&type=style&index=0&id=36093dc6&lang=scss&scoped=true"

import exportComponent from "/Users/koenverbruggen/Sites/02-SITES/nederlandsmijnmuseum.local/wp-content/themes/nmm/js/vue/nmm/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36093dc6"]])

export default __exports__